module.exports = __webpack_public_path__ + "static/ernesto_opt-78742d4209bba8a14922b0f136827c01.jpg";